export const SALES_ORDER_CANCEL_PERMISSION = 'sales_order.cancel';
export const LENS_REPLACEMENT_CREATE_PERMISSION = 'lens_replacement.create';
export const LENS_REPLACEMENT_SCRATCH_OVERRIDE_PERMISSION = 'lens_replacement.scratch_date_override';
